import { SearchTerm } from "./SearchTerm";

const ControllerSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    }
];

export default ControllerSearch;
